import { parse, Allow } from 'partial-json'
import json2md from 'json2md'
import { logger } from './logger'

/**
 * Parse partial/incomplete JSON string
 * Attempts to parse JSON even when it's incomplete (useful for streaming)
 * @param text - The JSON string to parse (may be incomplete)
 * @returns Parsed object if successful, null if parsing fails
 */
export function parsePartialJson(text: string): object | null {
    if (!text || !text.trim()) {
        return null
    }

    try {
        // Try parsing with Allow.ALL to handle partial JSON
        const parsed = parse(text, Allow.ALL)
        return parsed as object
    } catch (error) {
        // If parsing fails, return null
        // The caller can handle this by falling back to raw text
        return null
    }
}

/**
 * Convert JSON object to markdown format
 * @param json - The JSON object to convert
 * @returns Markdown string representation
 */
export function jsonToMarkdown(json: object): string {
    try {
        // json2md accepts object, array, or string
        // For objects, it expects a specific structure (h1, h2, p, etc.)
        // For generic JSON objects, we'll try to convert them
        const markdown = json2md(json)
        return markdown || ''
    } catch (error) {
        logger.error('Failed to convert JSON to markdown:', error)
        // Fallback: return stringified JSON if conversion fails
        return JSON.stringify(json, null, 2)
    }
}

